import Layout from "../../../components/layout";
import PageHeading from "../../../components/page-header";
import LogoSlider from "../../../components/logo-slider";

import fs from 'fs';
import path from 'path';

export async function getStaticProps() {
  const dir = path.join(process.cwd(), 'public/images/companies');
  const files = fs.readdirSync(dir);
  const logos = files.map((file) => `/images/companies/${file}`);

  return {
    props: { logos },
  };
}


export default function Sounds({ logos }) {

  return (
      <Layout>
        <PageHeading heading_text='Video' image_url={'/images/heroslider/video.webp'}/>

        <div className="section white-bg">
          <div className="container">
          <div className="row g-5 justify-content-center align-items-center">
            <div className="col-md-5 col-12">
                      <div className="heading-frame">
                        <div className="border-frame tr"></div>

                        <h2 className="text-right">Seamless Integration. Unified Control.</h2>

                        <div className="border-frame bl"></div>
                      </div>
                </div>
                <div className="col-md-5 col-12">
                        <h5 className="section-title">SEE THE DIFFERENCE WITH PROSLV VIDEO</h5>
                        <p className="section-description">From vibrant presentations to live event feeds, Proslv’s video systems deliver clarity, control, and confidence. Whether you're broadcasting across the globe or collaborating in-room, our solutions ensure every frame counts — sharp, synchronized, and seamless.
                           <br/> <br/>
                           Proslv video — engineered for impact.
                        </p>
                </div>
            </div>
          </div>
        </div>

        <div className="section black-bg client-section">

   <LogoSlider logos={logos}/>

    <div className="section-separator"></div>

    <div class="projects-section container mt-5">
    <h2 class="highlight-title mb-5">Our Projects</h2>
    <div class="projects-grid">
      <div class="project-card">
        <img src="/images/video/maersk_video.jpg" alt="Maersk Smart Port TV" />
        <h3>Maersk – Smart Port AV Integration</h3>
        <p>Coastal Ops Display Wall</p>
      </div>
      <div class="project-card">
        <img src="/images/video/movate_video.jpg" alt="Movate Executive AV" />
        <h3>Movate – Executive AV Experience Suite</h3>
        <p>Racing-Themed AV Suite</p>
      </div>
      <div class="project-card">
        <img src="/images/video/oneglance_video.jpg" alt="One Glance Control Room" />
        <h3>OneGlance – Control Room Intelligence Hub</h3>
        <p>Tech Command Desk</p>
      </div>
      <div class="project-card">
        <img src="/images/video/prulife_video.jpg" alt="PruLife Hive AV System" />
        <h3>Prulife HO - Hive AV System</h3>
        <p>Training Theater Setup</p>
      </div>
      
    </div>
  </div>
  </div>

      </Layout>
  );
}
